import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledLabel = styled.p`
  font-size: 1.2rem;
  font-weight: 700;
  line-height: 1.5;
  margin-bottom: ${({ theme }) => `calc(${theme.mainSpacing}/2)`};
`;
